import {useSocketContent} from "../../contexts/socket-content";
import Echart from "./Echart";
import {CFlex, Flex} from "../../styles/MarketStyles";
import {useEffect, useState} from "react";
import {useMainContext} from "../../contexts/main";
import {deepCopy, formatNumber} from "../../utils/common";
import {DepthCircleBox, DepthItem, DepthItemWrapper} from "../../styles/responsive/CommonStyles";
import Text from "../../utils/Text";


const DepthChart = () => {

    const { main: {theme, lang} } = useMainContext()
    const { buyOrders, sellOrders } = useSocketContent()

    const [depthOptions, setDepthOptions] = useState(depthItems)

    const [sellPrices, setSellPrices] = useState([])
    const [sellAmounts, setSellAmounts] = useState([])
    const [buyPrices, setBuyPrices] = useState([])
    const [buyAmounts, setBuyAmounts] = useState([])

    useEffect(() => {

        let concated = 0
        const newPrices = []
        const newAmounts = []
        if (sellOrders) {
            sellOrders.forEach(item => {
                concated += item.amount
                newPrices.push([item.priceUnit, concated.toFixed(4)])
                newAmounts.push([item.priceUnit, concated.toFixed(4)])
            })
            setSellPrices(newPrices)
            setSellAmounts(newAmounts)
        }
    }, [sellOrders])


    useEffect(() => {
        if (buyOrders) {
            let concated = 0
            const newPrices = []
            const newAmounts = []

            for (let i = 0; i < buyOrders.length; i++) {
                const item = buyOrders[i]
                concated += item.amount
                newPrices.push([item.priceUnit, concated.toFixed(4)])
                newAmounts.push([item.priceUnit, concated.toFixed(4)])
            }
            setBuyPrices(newPrices.reverse())
            setBuyAmounts(newAmounts.reverse())
        }

    }, [buyOrders])


    const option = {
        color: [
          '#1ce087',
          '#e9106c'
        ],
        xAxis: {
            type: 'value',
            data:
                (depthOptions[0].active && depthOptions[1].active) ? [...buyPrices, ...sellPrices]
                    : (
                        depthOptions[0].active ? buyPrices
                            :
                            (
                                depthOptions[1].active ? sellPrices : []
                            )
                    )
            ,
            min: function (value) {
                return value.min - 100;
            },
            max: function (value) {
                return value.max - 100;
            },
            scale: true,
            splitLine: {
                lineStyle: {
                    color: 'transparent'
                }
            },
            axisLabel: {show: false}
        },
        yAxis: {
            type: 'value',
            splitLine: {
                lineStyle: {
                    color: theme === 'dark' ? '#c3c5b720' : '#00000020',
                    type: 'dashed'
                }
            },
            scale: true
        },
        dataZoom: [
            {
                type: 'inside',
                start: 0,
                end: 100
            },
            {
                show: false,
                type: 'slider',
                top: '90%',
                start: 0,
                end: 100
            }
        ],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            },
            textStyle: {
              color: theme === 'dark' ? '#c3c5b7' : '#191c20',
                fontSize: 12
            },
            backgroundColor: theme === 'dark' ? 'rgb(43, 49, 57)' : '#fafafa',
            borderColor: '#fafafa90',
            position: lang === 'en' ? 'left' : 'right',
            formatter: (param) => {
                const formats = {
                    en: `
                        Amount: ${formatNumber(param[0].data[1])}<br />
                        Price: ${formatNumber(param[0].data[0])}
                    `,
                    fa: `
                        مقدار: ${formatNumber(param[0].data[1])} <br />
                        قیمت: ${formatNumber(param[0].data[0])}
                    `
                }
                return formats[lang]
            }
        },
        series: [
            {
                data: depthOptions[0].active ? buyAmounts : [],
                type: 'line',
                showSymbol: false,
                areaStyle: {
                    color: '#1ce087',
                    opacity: 0.6
                }
            },
            {
                data: depthOptions[1].active ? sellAmounts : [],
                type: 'line',
                showSymbol: false,
                areaStyle: {
                    color: '#f6465d',
                    opacity: 0.6
                }
            }
        ]
    };

    const onDepthOptionsClicked = (idx) => {
        const newOptions = deepCopy(depthOptions)
        newOptions[idx].active = !newOptions[idx].active
        setDepthOptions(newOptions)
    }

    return (
        <CFlex fw height={'180px'}>
            <Echart option={option} style={{ width: '100vw', height: '240px', minHeight: '240px', padding: '0 10px' }} />
            <DepthItemWrapper>
                {depthOptions.map((item, idx) => (
                    <Flex onClick={() => onDepthOptionsClicked(idx)}>
                        <DepthCircleBox buy={item.name === 'buy-orders'}/>
                        <DepthItem active={item.active}>
                            <Text tid={item.name} />
                        </DepthItem>
                    </Flex>
                ))}
            </DepthItemWrapper>
        </CFlex>
    )
}

const depthItems = [
    { name: 'buy-orders', active: true },
    { name: 'sell-orders', active: true }
]

export default DepthChart
